import Image1 from '@hotjar/shared-assets/images/integrations/hubspot/HubSpot-Hotjar-Integration-1.png';
import Image2 from '@hotjar/shared-assets/images/integrations/hubspot/HubSpot-Hotjar-Integration-2.png';
import Image3 from '@hotjar/shared-assets/images/integrations/hubspot/HubSpot-Hotjar-Integration-3.png';
import { IntegrationTokenName } from '../domains/api';
import type { Integration } from '../types';

export const hubspot: Integration = {
  slug: 'hubspot',
  icon: 'hubspot',
  name: 'integrations:hubspot.title',
  tokenName: IntegrationTokenName.Hubspot,
  provider: 'integrations:card.hotjar',
  actionLabel: {
    enable: 'integrations:details.header.hubspot-enable',
    disable: 'integrations:details.header.hubspot-disable',
  },
  description: 'integrations:hubspot.description-revamp',
  descriptionLarge: 'integrations:hubspot.description-large',
  resources: [
    {
      copy: 'integrations:hubspot.using-with-hotjar',
      url: '/articles/115009347167-Using-Hotjar-with-HubSpot',
      icon: 'page_full',
    },
  ],
  images: [Image1, Image2, Image3],
  videoUrl: null,
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
};
